import React, { useState, createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useOnUpdate from '../hooks/useOnUpdate';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (data) => {
    const newState = [...notifications, data];
    setNotifications(newState);
  };

  const removeNotification = (index) => {
    const filterAlerts = notifications.filter((_, i) => index !== i);
    setNotifications(filterAlerts);
  };

  const contextObject = useMemo(() => ({ notifications, addNotification, removeNotification }), [notifications]);

  useOnUpdate(() => {
    if (notifications.length > 0) {
      setTimeout(() => {
        setNotifications([]);
      }, 5000);
    }
  }, [notifications]);

  return <NotificationContext.Provider value={contextObject}>{children}</NotificationContext.Provider>;
}

NotificationProvider.propTypes = {
  children: PropTypes.object,
};

NotificationProvider.defaultProps = {
  children: {},
};

export const useNotification = () => useContext(NotificationContext);
